class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.closeTimer = null;

    this.addEventListener('mouseenter', this.onDesktopPointerEnter.bind(this));
    this.addEventListener('mouseleave', this.onDesktopPointerLeave.bind(this));
    this.summary.addEventListener('focus', this.openDesktopMenu.bind(this));
    this.addEventListener('keydown', this.onDesktopKeyDown.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  onDesktopPointerEnter() {
    this.openDesktopMenu();
  }

  onDesktopPointerLeave() {
    if (!this.desktopMediaQuery.matches) return;

    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => {
      if (!this.contains(document.activeElement)) this.closeDesktopMenu();
    }, 140);
  }

  onDesktopKeyDown(event) {
    if (event.key !== 'Escape' || !this.mainDetailsToggle.open) return;

    event.preventDefault();
    this.closeDesktopMenu();
    this.summary.focus();
  }

  openDesktopMenu() {
    if (!this.desktopMediaQuery.matches) return;

    window.clearTimeout(this.closeTimer);
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  closeDesktopMenu() {
    window.clearTimeout(this.closeTimer);
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('header-menu', HeaderMenu);
